module.exports = __webpack_public_path__ + "img/mobileVideo3.562143ed.png";